import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { FloatingMenuComponent } from './floating-menu.component';

@NgModule({
    imports: [CommonModule, TwcModule, TranslateModule],
    declarations: [FloatingMenuComponent],
    exports: [FloatingMenuComponent],
})
export class FloatingMenuModule {}
